type ModalProps = {
  title: string;
  closeAction: () => void;
  children: React.ReactNode;
  footerContent: React.ReactNode;
};

export const Modal = ({
  title,
  closeAction,
  children,
  footerContent,
}: ModalProps) => {
  return (
    <>
      <div className="position-fixed top-0 bottom-0 start-0 end-0 bg-black bg-opacity-10 d-flex align-items-start justify-content-center z-1 p-5 overflow-y-auto">
        <div className="w-100 bg-white rounded-1 border border-primary">
          <header className="bg-primary p-2 text-white fw-medium d-flex justify-content-between">
            {title}
            {/* <button type="button" className="" onClick={closeAction}>
              <i className="bi bi-x-lg"></i>
            </button> */}
          </header>
          <div className="w-100 px-3 py-2">
            <div className="">{children}</div>
            <div className="w-100 d-flex justify-content-center border-top pt-2 mt-2 gap-2">
              {footerContent ? (
                footerContent
              ) : (
                <button className="btn btn-primary" onClick={closeAction}>
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
